<template>
    <div class="BackgroundConteudoSlides">
        <div class="mySlides">
            <div class="numbertext">1 / 5</div>
                    <mq-layout mq="xl">
                        <b-img-lazy 
                            :src="require('../../assets/InicioHion-hd.jpg')"
                            alt="Hion é Tecnologia" 
                            class="imgSlides"
                            >
                        </b-img-lazy>
                    </mq-layout>
                    <mq-layout mq="lg">
                        <b-img-lazy 
                            :src="require('../../assets/InicioHion-lg.jpg')"
                            alt="Hion é Tecnologia" 
                            class="imgSlides"
                            >
                        </b-img-lazy>
                    </mq-layout>
                    <mq-layout :mq="['sm', 'md']">
                        <b-img-lazy 
                            :src="require('../../assets/InicioHion-sm.jpg')"
                            alt="Hion é Tecnologia" 
                            class="imgSlides"
                            >
                        </b-img-lazy>
                    </mq-layout>
                    <mq-layout mq="xs">
                        <b-img-lazy 
                            :src="require('../../assets/InicioHion-xs.jpg')"
                            alt="Hion é Tecnologia" 
                            class="imgSlides"
                            >
                        </b-img-lazy>
                    </mq-layout>
                    <div class="tituloSlider">Tecnologia do Futuro</div>
                    <div class="textSlider">Sistemas de Armazenamento de Energia, 
                                        Veículos Elétricos e Híbridos, Sistemas Embarcados, IoT, 
                                        Gestão de Projetos e Gestão da Qualidade.
                    </div>
        </div>
<!--
        <div class="mySlides">
            <div class="numbertext">2 / 5</div>
            <router-link to="/Tecnologia">
                <b-img-lazy 
                    :src="require('../../assets/templateTamanhoTelas.jpg')"
                    alt="Template Fotos" 
                    class="imgSlides"
                    >
                </b-img-lazy>
            </router-link>
        </div> -->
<!--
        <div class="mySlides">
            <div class="numbertext">3 / 5</div>
            <router-link to="/KinderBMS">
                <mq-layout mq="md+">
                    <b-img-lazy :src="require('../../assets/slide3_jan20.jpg')" fluid-grow></b-img-lazy>
                </mq-layout>
                <mq-layout :mq="['xs', 'sm']">
                    <b-img-lazy :src="require('../../assets/slide3_SM_jan20.jpg')" fluid-grow></b-img-lazy>
                </mq-layout>
            </router-link>
        </div>

        <div class="mySlides">
            <div class="numbertext">4 / 5</div>
            <router-link to="/Login">
                <mq-layout mq="md+">
                    <b-img-lazy :src="require('../../assets/slide4_jan20.jpg')" fluid-grow></b-img-lazy>
                </mq-layout>
                <mq-layout :mq="['xs', 'sm']">
                    <b-img-lazy :src="require('../../assets/slide4_SM_jan20.jpg')" fluid-grow></b-img-lazy>
                </mq-layout>
            </router-link>
        </div>

        <div class="mySlides">
            <div class="numbertext">5 / 5</div>
            <router-link to="/Empilhadeiras">
                <mq-layout mq="md+">
                    <b-img-lazy :src="require('../../assets/slide5_jan20.jpg')" fluid-grow></b-img-lazy>
                </mq-layout>
                <mq-layout :mq="['xs', 'sm']">
                    <b-img-lazy :src="require('../../assets/slide5_SM_jan20.jpg')" fluid-grow></b-img-lazy>
                </mq-layout>
            </router-link>
        </div>
-->
        <a class="prev" @click="voltaSlider">&#10094;</a>
        <a class="next" @click="passaSlider">&#10095;</a>

    </div>   
</template>

<script>
let slideIndex;
let slides;
let Transicao;
let TimerLigado;

export default {

    name: 'HomeSlides',
    data() {
            return {
            };
    },
    methods: {
        voltaSlider() {
            this.desligaTimer();
            slides[slideIndex].style.display = "none";
            if(slideIndex <= 0) slideIndex = (slides.length - 1);
                else slideIndex--;
            slides[slideIndex].style.display = "block";
            this.ligaTimer();
        },
        passaSlider() {
            this.desligaTimer();
            slides[slideIndex].style.display = "none";
            if(slideIndex >= (slides.length-1)) slideIndex = 0;
                else slideIndex++;
            slides[slideIndex].style.display = "block";
            this.ligaTimer();
        },
        montedSlides() {
            this.desligaTimer();
            slideIndex = 0;
            TimerLigado = 1;
            slides = document.getElementsByClassName("mySlides");
            for (let i = 0; i < slides.length; i++) {
                slides[i].style.display = "none";
            }
            slides[0].style.display = "block";
            Transicao = setInterval(this.showSlides, 8000);
        },
        showSlides() {
            if(TimerLigado) {
                slides[slideIndex].style.display = "none";
                if(slideIndex >= (slides.length-1)) slideIndex = 0;
                    else slideIndex++;
                slides[slideIndex].style.display = "block";
            }
        },
        ligaTimer() {
            if (!TimerLigado) {
                TimerLigado = 1;
                Transicao = setInterval(this.showSlides, 8000);
            }
        },
        desligaTimer() {
            clearInterval(Transicao);
            TimerLigado = 0;
        }
    },
    mounted() {
        this.montedSlides();
    },
    destroyed () {
        this.desligaTimer();
    }
}
</script>

<style>
.BackgroundConteudoSlides {
    box-sizing:border-box;
    position: relative;
    width: 100%;
    height: 100%;
    margin: auto;
}
.mySlides {
    display: none;
}
.imgSlides {
    width: 1920px;
    height: 650px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.prev, .next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  margin-top: -50px;
  padding: 16px;
  color: rgb(138, 137, 137);
  font-weight: bold;
  font-size: 2em;
  border-radius: 0 3px 3px 0;
  user-select: none;
}

.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}
.prev:hover, .next:hover {
  background-color: rgba(0,0,0,0.8);
}
.tituloSlider {
    color: #eee;
    font-size: 52px;
    font-weight: bolder;
    font-family: 'Raleway', 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Verdana, sans-serif;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.textSlider {
    color: #eee;
    font-size: 16px;
    text-align: center;
    font-family: 'Raleway', 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Verdana, sans-serif;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 550px;
}
.numbertext {
  color: #eeeeee;
  font-size: 1.3em;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

/* MEDIA QUERY LG ***************************************************************/
@media (min-width: 992px) and (max-width:1366px) { /* LG */
    .imgSlides {
        width: 1366px;
    }
    .tituloSlider {
        font-size: 48px;
    }
    .textSlider {
        font-size: 14px;
        max-width: 500px;
    }
}
/* ******************************************************************************/

/* MEDIA QUERY SM MD ************************************************************/
@media (min-width: 576px) and (max-width:991px) { /* SM MD */
    .imgSlides {
        width: 991px;
    }
    .tituloSlider {
        font-size: 28px;
        top: 35%;
    }
    .textSlider {
        font-size: 14px;
        max-width: 420px;
    }
}
/* ******************************************************************************/

/* MEDIA QUERY XS ***************************************************************/
@media (max-width:575px) { /* XS */
    .imgSlides {
        width: 575px;
    }
    .tituloSlider {
        font-size: 28px;
        text-align: center;
        top: 30%;
    }
    .textSlider {
        font-size: 14px;
        max-width: 280px;
        top: 55%;
    }
}
/* ******************************************************************************/

</style>